import { isEmpty } from '@sgme/fp';
import { HStack, VStack } from '@sgme/ui';

import RightColumnHeader from '@/App/tiles/ForwardAccumulator/parts/RightColumnHeader.tsx';
import { InputGroup1 } from '@/App/tiles/ForwardAccumulator/parts/RightPanel/common/InputGroup1.tsx';
import { InputGroup2 } from '@/App/tiles/ForwardAccumulator/parts/RightPanel/common/InputGroup2.tsx';
import { InputGroup3 } from '@/App/tiles/ForwardAccumulator/parts/RightPanel/common/InputGroup3.tsx';
import { InputGroup4 } from '@/App/tiles/ForwardAccumulator/parts/RightPanel/common/InputGroup4.tsx';
import Header from '@/App/tiles/ForwardAccumulator/parts/RightPanel/Scheduler/Header/index.tsx';
import { NoSchedule } from '@/App/tiles/ForwardAccumulator/parts/RightPanel/Scheduler/NoSchedule.tsx';
import SchedulerTable from '@/App/tiles/ForwardAccumulator/parts/RightPanel/Scheduler/Table/index.tsx';
import { useForwardAccumulatorSelector } from '@/App/tiles/ForwardAccumulator/ProductProvider.tsx';

const ZoomedTileSchedulerView = () => {
  const hasSchedule = useForwardAccumulatorSelector(
    (forwardAccumulator) => !isEmpty(forwardAccumulator.properties.scheduleIds),
  );

  return (
    <VStack flex="expand" verticalAlignment="start" className="align-self-stretch">
      <RightColumnHeader />
      <HStack flex="expand" verticalAlignment="start" gap="4px" horizontalAlignment="start">
        <VStack className="m-8px p-8px border">
          <span className="active ms-16px mb-8px">Schedule parameters</span>
          <VStack>
            <VStack className="p-4px">
              <div>
                <InputGroup1 />
              </div>

              <div className="mt-3">
                <InputGroup2 />
              </div>
            </VStack>

            <VStack verticalAlignment="start">
              <div className="mt-3">
                <InputGroup3 />
              </div>
              <div className="mt-3">
                <InputGroup4 />
              </div>
            </VStack>
          </VStack>
        </VStack>
        {hasSchedule ? (
          <VStack className="border m-2 h-100">
            <Header />
            <SchedulerTable />
          </VStack>
        ) : (
          <div className="border m-2 p-2 w-100 h-75">
            <NoSchedule />
          </div>
        )}
      </HStack>
    </VStack>
  );
};

export default ZoomedTileSchedulerView;
